import React, { useEffect, useState } from 'react';
import { FaChevronRight, FaSearch } from 'react-icons/fa';
import $ from 'jquery';
import './style.scoped.scss';
import { connect } from 'react-redux';
import TabIndexBtn from '../Buttons/TabIndex';

const Search = ({
  handleSearch,
  displaySearch,
  clientInfo,
  isExpanded: isParentExpanded,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [isExpanded, setIsExpanded] = useState(isParentExpanded);

  useEffect(() => {
    setIsExpanded(isParentExpanded);
  }, [isParentExpanded]);

  const handleInput = (e) => {
    setSearchValue(e.target.value);
    if (e.keyCode === 13 || e.which === 13) {
      e.preventDefault();
      handleSearchClick(e.target.value);
    }
  };

  const handleSearchClick = (value) => {
    handleSearch(value ? value : searchValue);
  };

  const handleDisplaySearch = () => {
    displaySearch();
    setIsExpanded(true);
  };

  const collapseSearch = () => {
    setIsExpanded(false);
    setSearchValue('');
    handleSearch('');
  };

  useEffect(() => {
    $('.tooltip').tooltip('hide');
    if (isExpanded && document.getElementById('modalSearch'))
      document.getElementById('modalSearch').focus();
  }, [isExpanded]);

  $('[data-toggle="tooltip"]').tooltip();

  return (
    <React.Fragment>
      {isExpanded ? (
        <div className='modal-search-wrapper'>
          <FaChevronRight
            color='white'
            className='mr-3'
            fontSize='2.25em'
            onClick={collapseSearch}
            onMouseEnter={() => $('[data-toggle="tooltip"]').tooltip()}
            data-toggle='tooltip'
            title='Hide search'
            data-container='#DocsListModal'
            data-original-title='Hide search'
          />
          <div className='search search--modal'>
            <input
              className='search__input'
              placeholder='Search...'
              id='modalSearch'
              onKeyDown={handleInput}
              onChange={handleInput}
            />

            <FaSearch
              onClick={() => handleSearchClick()}
              onMouseEnter={() => $('[data-toggle="tooltip"]').tooltip()}
              data-toggle={searchValue.length < 1 ? 'tooltip' : ''}
              title={
                searchValue.length < 1
                  ? 'Please enter a search term.'
                  : 'Standard Search'
              }
              data-original-title={
                searchValue.length < 1
                  ? 'Please enter a search term.'
                  : 'Standard Search'
              }
              className={`mx-2 search__click${
                searchValue.length > 0 ? '' : ' disabled'
              }`}
              data-container='#DocsListModal'
            />
          </div>
        </div>
      ) : (
        <TabIndexBtn handleClick={handleDisplaySearch}>
          <FaSearch
            color='white'
            className='mr-3'
            data-toggle='tooltip'
            onMouseEnter={() => $('[data-toggle="tooltip"]').tooltip()}
            title={`Search ${
              clientInfo ? 'this ' + clientInfo.LevelOne : 'Documents'
            }`}
            data-original-title={`Search ${
              clientInfo ? 'this ' + clientInfo.LevelOne : 'Documents'
            }`}
            data-container='#DocsListModal'
          />
        </TabIndexBtn>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  clientInfo: state.client.spStructure,
});

const connector = connect(mapStateToProps);

export default connector(Search);
